import React from 'react';
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {bookingActions, bookingSelector, QuoteObj, SpecialServiceType} from "../../../../features/bookingSlice";
import {AMIFormElement, AMISelect} from "../../../../ui-components/UiComponents";

const SignatureCard: React.FC<{
    errHandler: any;
    selectedQuote: any;
}> = ({
  errHandler,
  selectedQuote,
}) => {
    const dispatch = useAppDispatch();

    const chargeIsOfType = (quote: QuoteObj, type: string): boolean => {
        return quote.charges.optional?.every(charge => charge.type !== type) ?? true;
    };

    const handleSignatureCard = (event: any) => {
        dispatch(bookingActions.updateField({
            field: 'signatureOption',
            value: event.value,
        }));
    }

    return (
      <div className="signature-card">
          <p className="horizontal-card__title">Signature Option</p>

          <AMIFormElement label="Select a Signature Option">
              <AMISelect
                name="signatureOption"
                size="large"
                options={[
                    {
                        title: "Indirect Signature",
                        value: SpecialServiceType.INDIRECT_SIGNATURE,
                        disabled: chargeIsOfType(selectedQuote, "INDIRECT_SIGNATURE"),
                    },
                    {
                        title: "Direct Signature",
                        value: SpecialServiceType.DIRECT_SIGNATURE,
                        disabled: chargeIsOfType(selectedQuote, "DIRECT_SIGNATURE"),
                    },
                    {
                        title: "Adult Signature",
                        value: SpecialServiceType.ADULT_SIGNATURE,
                        disabled: chargeIsOfType(selectedQuote, "ADULT_SIGNATURE"),
                    }
                ]}
                onChange={handleSignatureCard}
              />
          </AMIFormElement>



      </div>
    )
}

export default SignatureCard;